<template>
    <v-container fluid>
      <vueHeadful
      :title="this.$i18n.t('Menu.Magazine') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
      <template v-if="historial === false">
        <!-- EDITORIAL -->
        <v-row name="Editorial" style="margin: 5%;" v-if="editorial">
          <v-col cols="12" xs="12" md="4" order="1">
            <v-img :src="editorial.imagenPrincipal" height="100%" position="top center"/>
          </v-col>
          <v-col cols="12" xs="12" md="4" :style="columnas" style="align-self:center;" >
            <h5 class="descripcion">{{ $t('Categoria.'+editorial.categoria) }} - {{ $t('Mes.'+ editorial.mes) }}/{{ editorial.ano }}</h5>
            <p class="descripcion font-weight-light text-justify" v-if="getIdioma === 'es'">{{editorial.resumenEs}}</p>
            <p class="descripcion font-weight-light text-justify" v-else>{{editorial.resumenEn}}</p>
            <p class="descripcion font-weight-light text-justify" v-if="editorial.autor">{{$t('Formularios.Por')}} {{editorial.autor}}</p>
            <v-btn :to="$t('Alias.Articulo')+'/'+ editorial.enlace" class="botonRaro" large color="secondary">{{$t('Inicio.LeerArticulo')}}</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="4" order="3" style="align-self:center">
            <h1 class="tituloMagazine" :style="responsiveTitulo+'color: #26A69A;'" v-if="getIdioma === 'es'">{{editorial.tituloEs.toUpperCase()}}</h1>
            <h1 class="tituloMagazine" :style="responsiveTitulo+'color: #26A69A;'" v-else>{{editorial.tituloEn.toUpperCase()}}</h1>
          </v-col>
        </v-row>
        <!-- INVITADO -->
        <v-row name="Invitado" style="background:#4180FF;padding: 7% 5%;" v-if="invitado">
          <v-col cols="12" xs="12" md="4" order="2" class="px-5" style="align-self:center">
            <h1 class="tituloMagazine" :style="responsiveTitulo+'color: #FFFFFF;'" v-if="getIdioma === 'es'">{{invitado.tituloEs}}</h1>
            <h1 class="tituloMagazine" :style="responsiveTitulo+'color: #FFFFFF;'" v-else>{{invitado.tituloEn}}</h1>
          </v-col>
          <v-col cols="12" xs="12" md="4" order="3" align="right" style="align-self:center;padding-left: 5%;">
            <h5 class="descripcion">{{ $t('Categoria.'+invitado.categoria) }} - {{ $t('Mes.'+invitado.mes) }}/{{ invitado.ano }}</h5>
            <p class="descripcion font-weight-light text-justify" v-if="getIdioma === 'es'">{{invitado.resumenEs}}</p>
            <p class="descripcion font-weight-light text-justify" v-else>{{invitado.resumenEn}}</p>
            <p class="descripcion font-weight-light text-justify" v-if="invitado.autor">{{$t('Formularios.Por')}} {{invitado.autor}}</p>
            <v-btn :to="$t('Alias.Articulo')+'/'+ invitado.enlace" class="botonRaro" color="secondary" large>{{$t('Inicio.LeerArticulo')}}</v-btn>
          </v-col>
          <v-col cols="12" xs="12" md="4" class="columnasEditorial">
            <v-img :src="invitado.imagenPrincipal" height="100%" position="top center"/>
          </v-col>
        </v-row>
        <!-- STORIES -->
        <v-row name="Stories" class="padding" v-if="stories">
          <v-col cols="12" align="center">
            <h1 :style="responsiveTitulo" class="primary--text" style="padding:60px 0!important;">STORIES</h1>
          </v-col>
          <v-col cols="4" v-for="i in stories.slice(0,3)" :key="i.titulo">
            <router-link :to="$t('Alias.Articulo')+'/'+ i.enlace">
              <div style="background:#000000;">
                <v-hover v-slot:default="{ hover }">
                  <v-img :id="hover ? 'historial' : ''" :src="i.imagenPrincipal" aspect-ratio="1">
                    <v-container fill-height style="justify-content: center">
                      <v-row width="100%">
                      <v-col cols="12" align="center" justify="center" v-if="hover">
                        <span class="vietnam white--text" style="font-size:32px;" v-if="getIdioma === 'es'">{{i.tituloEs}}</span>
                        <span class="vietnam white--text" style="font-size:32px;" v-else>{{i.tituloEn}}</span>
                      </v-col>
                    </v-row>
                    </v-container>
                  </v-img>
                </v-hover>
              </div>
            </router-link>
          </v-col>
        </v-row>
        <v-row name="Historial">
          <v-col cols="12" align="center">
            <h3 :style="historialTitulo + 'cursor:pointer;letter-spacing:8px;'" class="error--text" @click="historial = true">{{$t('Busqueda.Historial')}}</h3>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row style="padding: 0 5%;">
          <v-col cols="12" align="center">
            <h3 :style="responsiveTitulo + 'letter-spacing:8px;padding: 60px 0'" class="primary--text">{{$t('Busqueda.Historial')}}</h3>
          </v-col>
          <v-col cols="6" xs="6" sm="4" md="3" lg="2" v-for="i in articulos" :key="i.enlace" align="center">
            <v-row>
              <v-col cols="12">
                <span class="vietnam font-weight-bold" style="font-size:18px;">{{ $t('Categoria.'+i.categoria) }}</span>
                <br>
                <span class="vietnam" style="font-size:18px;">{{ $t('Mes.'+i.mes) }}/{{ i.ano }}</span>
                <router-link :to="$t('Alias.Articulo')+'/'+ i.enlace">
                  <div style="background:#000000;">
                    <v-hover v-slot:default="{ hover }">
                      <v-img :id="hover ? 'historial' : ''" :src="i.imagenPrincipal" aspect-ratio="1">
                        <v-container fill-height style="justify-content: center">
                          <v-row width="100%">
                          <v-col cols="12" align="center" justify="center" v-if="hover">
                            <span class="vietnam white--text" style="font-size:18px;" v-if="getIdioma === 'es'">{{i.tituloEs}}</span>
                            <span class="vietnam white--text" style="font-size:18px;" v-else>{{i.tituloEn}}</span>
                          </v-col>
                        </v-row>
                        </v-container>
                      </v-img>
                    </v-hover>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn outlined style="border: 2px solid" x-large class="ma-3" @click="historial = false">{{$t('Inicio.VolverMagazine')}}</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Magazine',
  data () {
    return {
      invitado: null,
      editorial: null,
      stories: [],
      historial: false,
      articulos: []
    }
  },
  mounted () {
    this.historial = false
    if (this.getArticulos[0]) {
      this.ordenarArticulos()
    } else {
      var articulos = []
      firebase.firestore().collection('magazine').get().then(response => {
        for (let i = 0; i < response.docs.length; i++) {
          if (response.docs[i].data().publicar === false) {
            continue
          } else {
            articulos.push(response.docs[i].data())
          }
        }
        this.setArticulos(articulos)
        this.ordenarArticulos()
      })
    }
  },
  methods: {
    ...mapMutations(['setArticulos']),
    ordenarArticulos () {
      var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      var ordenadoPorMes = this.getArticulos.sort(function (a, b) {
        return meses.indexOf(b.mes) -
              meses.indexOf(a.mes)
      })
      this.articulos = ordenadoPorMes.sort(function (a, b) {
        return b.ano - a.ano
      })
      this.filtrar(this.articulos)
    },
    filtrar (articulos) {
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Invitado' && articulos[i].publicar === true) {
          this.invitado = articulos[i]
          break
        }
      }
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Editorial' && articulos[i].publicar === true) {
          this.editorial = articulos[i]
          break
        }
      }
      for (let i = 0; i < articulos.length; i++) {
        if (articulos[i].categoria === 'Stories' && articulos[i].publicar === true) {
          this.stories.push(articulos[i])
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getArticulos', 'getIdioma']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:3.5rem;'
        case 'xl': return 'font-size:4rem;line-height:3.5rem;'
        default: return 'font-size:4rem;line-height:3.5rem;'
      }
    },
    historialTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:1rem;line-height:2rem;'
        case 'sm': return 'font-size:1.5rem;line-height:1.5rem;'
        case 'md': return 'font-size:2rem;line-height:2rem;'
        case 'lg': return 'font-size:2.5rem;line-height:2.5rem;'
        case 'xl': return 'font-size:3rem;line-height:3rem;'
        default: return 'font-size:3rem;line-height:3rem;'
      }
    },
    columnas () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'order: 4;'
        case 'sm': return 'order: 4;'
        case 'md': return 'order: 2;'
        case 'lg': return 'order: 2;'
        case 'xl': return 'order: 2;'
        default: return 'order: 2;'
      }
    },
    columnasEditorial () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'order: 1;'
        case 'sm': return 'order: 1;'
        case 'md': return 'order: 4;'
        case 'lg': return 'order: 4;'
        case 'xl': return 'order: 4;'
        default: return 'order: 4;'
      }
    }
  },
  watch: {
    historial (n, v) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style>
#historial .v-image__image{
  opacity: 0.6!important;
}
.tituloMagazine {
  font-family: 'Be Vietnam', sans-serif!important;
  font-weight: 600!important;
}
</style>
